/* eslint-disable no-alert */
import React, { useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  Row, Col, Card, CardBody, CardTitle,
} from 'reactstrap';
import { withTranslation } from 'react-i18next';

import toastr from 'toastr';
import 'toastr/build/toastr.min.css';

import { post } from '../../helpers/api_helper';
import { Can } from '../../utilities/Can';
import BaseGrid from '../../components/Common/BaseGrid';

import KitFormModal from '../../components/Inventory/KitFormModal';

function Kits(props) {
  toastr.options = {
    positionClass: 'toast-top-right',
    newestOnTop: true,
    timeOut: 8000,
  };

  const { t } = props;

  const [signal, setSignal] = useState(0);
  const [kitModal, setKitModal] = useState(false);

  const deleteKit = async (row) => {
    if (window.confirm(props.t('Are you sure you want to delete this kit?'))) {
      await post('/api/inventory/kit/delete', { id: row.id });
      setSignal(signal + 1);
    }
  };

  const editKit = (row) => {
    setKitModal(row);
  };

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Row>
          <Col xxl="10">
            <Card>
              <CardBody>
                <CardTitle className="h4">{t('Kits')}</CardTitle>

                <Can i="see" this="inventory">
                  <BaseGrid
                    url="/api/inventory/kit"
                    shouldUpdate={signal}
                    hasSearch
                    create={() => setKitModal({ stock_id: '', items: [] })}
                    config={
                    {
                      columns: {
                        thumb: {
                          label: '',
                          image: {
                            src: (item) => (`/api/inventory/kit/thumbnail/${item.id}`),
                            class: 'rounded',
                            style: { maxHeight: '5rem', maxWidth: '5rem' },
                          },
                          translate: false,
                        },
                        stock_id: {
                          label: props.t('Stock ID'),
                          sort: true,
                          link: {
                            to: '/kits/%id%',
                          },
                        },
                        sku: {
                          label: props.t('SKU'),
                          sort: true,
                        },
                        items: {
                          label: props.t('Items'),
                          sort: true,
                          format: (value) => (value.map((x) => x.inventory && x.inventory.part_number).join(', ')),
                        },
                        qty: {
                          label: props.t('Shelf Qty'),
                          sort: true,
                        },
                        actions: {
                          label: 'Actions',
                          actions: [
                            {
                              key: 'edit_kit',
                              icon: 'mdi mdi-pencil',
                              class: 'btn btn-sm btn-soft-warning text-dark',
                              alt: 'Edit Kit',
                              click: editKit,
                            },
                            {
                              key: 'remove_kit',
                              icon: 'mdi mdi-close-thick',
                              class: 'btn btn-sm btn-soft-danger text-dark',
                              alt: 'Delete Kit',
                              click: deleteKit,
                            },
                          ],
                        },
                      },
                      pagination: {
                        sort: 'id',
                        direction: 'desc',
                        perPage: 30,
                      },
                    }
                    }
                  />

                  <KitFormModal
                    shown={kitModal !== false}
                    kit={kitModal !== false ? kitModal : { stock_id: '', items: [] }}
                    onSuccess={() => {
                      setSignal(signal + 1);
                      setKitModal(false);
                    }}
                  />
                </Can>

                <Can not i="see" this="inventory"><p>{props.t('Unauthorized')}</p></Can>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  );
}

Kits.propTypes = {
  // eslint-disable-next-line react/require-default-props
  t: PropTypes.any,
};

export default connect(() => ({

}), {})(withTranslation()(Kits));
